import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>HEM SALES AGENCIES</h3>
            <p>
              Professional sales solutions for modern businesses. Your partner
              in achieving sustainable growth and sales excellence.
            </p>
            {/* <div className="social-links">
              <a href="#" className="social-link">
                📘
              </a>
              <a href="#" className="social-link">
                🐦
              </a>
              <a href="#" className="social-link">
                💼
              </a>
              <a href="#" className="social-link">
                📧
              </a>
            </div> */}
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <a href="#home">Home</a>
              </li>
              <li>
                <a href="#services">Services</a>
              </li>
              <li>
                <a href="#about">About</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Our Services</h4>
            <ul>
              <li>
                <a href="#">Sales Analytics & Reporting</a>
              </li>
              <li>
                <a href="#">Lead Generation & Prospecting</a>
              </li>
              <li>
                <a href="#">Sales Training & Development</a>
              </li>
              <li>
                <a href="#">Growth Strategy & Planning</a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Information</h4>
            <p>📧 info@hemsalesagencies.com</p>
            <p>📞 +91 9321037171</p>
            <p>📍 Shop No. G-27, Ground Floor, White Pearls, Adajan</p>
            <p>Surat, Gujarat – 395009</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 HEM SALES AGENCIES. All rights reserved.</p>
          <div className="footer-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
            <a href="#">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
